import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import Tabs, { Tab } from '../../library/tabs/tabs';
import SizeTable from './components/size-table/size-table';
import SpecsTable from './components/specs-table/specs-table';
import LazyLoad from '../lazy-load/lazy-load';
import { HEADING_TITLES } from './product-specifications-constants';

import {
  ProductProp,
  ProductTypeProp
} from '../../shared/utils/prop-types/prop-types';
import { isArrayWithLength } from '../../shared/utils/validators/validators';

import styles from './product-specifications.scss';

function ProductSpecifications(props) {
  const {
    className,
    hideSizeTable,
    isCanonicalSearch,
    onSizeSelected,
    product,
    productType,
    selectedFitment,
    storeCode,
    tooltips
  } = props;
  const { aggregates, rearProduct } = product || {};
  const isStaggered = Boolean(rearProduct);
  const headerType = HEADING_TITLES[productType];
  const canonicalSpecs = useMemo(getCanonicalSpecs, [
    aggregates?.propertyRanges
  ]);

  const staggeredTitle = (
    <span>
      {headerType?.SPECS}
      <span className={styles['spec-subtitle']}>Front / Rear</span>
    </span>
  );

  function getTabs() {
    let tabs;

    if (productType === 'ACCESSORIES') {
      tabs = [headerType];
    } else if (isStaggered) {
      tabs = [staggeredTitle];
    } else if (!hideSizeTable) {
      tabs = [headerType?.SIZES, headerType?.SPECS];
    } else {
      tabs = [headerType?.SPECS];
    }
    return tabs;
  }

  const tabs = getTabs();

  const [selectedTab, setSelectedTab] = useState(tabs?.[0]);

  function getCanonicalSpecs() {
    let specs = null;

    if (Array.isArray(aggregates?.propertyRanges)) {
      specs = {};
      for (let i = 0; i < aggregates.propertyRanges?.length; i++) {
        const property = aggregates.propertyRanges[i];
        let propName = property?.name;

        if (propName === 'boltPattern') {
          propName = 'boltPatternVal';
        } else if (propName === 'gtin') {
          propName = 'gtin';
        }

        specs[propName] = property?.rangeValue;
      }
    }

    return specs;
  }

  if (!product) {
    return null;
  }

  return (
    <div className={className}>
      <Tabs className={styles['header-tabs']} isSecondary>
        {isArrayWithLength(tabs) &&
          tabs.map(tab => (
            <h2 key={`tab-${tab}`}>
              <Tab
                aria-selected={tab === selectedTab}
                isSelected={tab === selectedTab}
                onClick={() => setSelectedTab(tab)}
              >
                {tab}
              </Tab>
            </h2>
          ))}
      </Tabs>
      <LazyLoad>
        {(isStaggered ||
          productType === 'ACCESSORIES' ||
          selectedTab === headerType?.SPECS) && (
          <SpecsTable
            canonicalSpecs={canonicalSpecs}
            isStaggeredFitment={selectedFitment?.isStaggered}
            product={product}
            productType={productType}
            tooltips={tooltips}
          />
        )}

        {selectedTab && selectedTab === headerType?.SIZES && !hideSizeTable && (
          <SizeTable
            isCanonicalSearch={isCanonicalSearch}
            onSizeSelected={onSizeSelected}
            product={product}
            productType={productType}
            selectedFitment={selectedFitment}
            storeCode={storeCode}
          />
        )}
      </LazyLoad>
    </div>
  );
}

ProductSpecifications.propTypes = {
  className: PropTypes.string,
  hideSizeTable: PropTypes.bool,
  isCanonicalSearch: PropTypes.bool,
  onSizeSelected: PropTypes.func,
  product: ProductProp,
  productType: ProductTypeProp,
  selectedFitment: PropTypes.object,
  storeCode: PropTypes.string,
  tooltips: PropTypes.object
};

export default ProductSpecifications;
